import create from 'zustand';

const useUndoActionStore = create(set => ({
  // Store only a single undoable action and its associated URL
  currentAction: null,
  previousUrl: null,
  undoActionDisabled: false,

  // Set the current undoable action and capture the URL
  setUndoableAction: actionUUID => {
    if (!actionUUID) return;

    const currentUrl =
      typeof window !== 'undefined' ? window.location.pathname + window.location.search : null;

    set({ currentAction: actionUUID, previousUrl: currentUrl });
  },

  // Set whether the undo action should be disabled
  setUndoActionDisabled: disabled => set({ undoActionDisabled: disabled }),

  // Clear the undoable action data
  clearUndoableAction: () =>
    set({ currentAction: null, previousUrl: null, undoActionDisabled: false }),

  // Check if an action is the current undoable action
  isActionUndoable: actionUUID =>
    actionUUID && useUndoActionStore.getState().currentAction === actionUUID,

  // Get the current undoable action
  getCurrentAction: () => useUndoActionStore.getState().currentAction,

  // Get the previous URL
  getPreviousUrl: () => useUndoActionStore.getState().previousUrl,

  // Get whether the undo action is disabled
  getUndoActionDisabled: () => useUndoActionStore.getState().undoActionDisabled,
}));

export default useUndoActionStore;
